import { Article, ArticleStatus } from '../types';

export function getArticleStatus(article: Article): ArticleStatus {
  if (!article.id) {
    return 'draft';
  }

  const now = new Date();

  if (article.archivedAt && new Date(article.archivedAt) <= now) {
    return 'archived';
  }

  if (article.publishedAt && new Date(article.publishedAt) <= now) {
    return 'published';
  }

  if (article.publishedAt) {
    return 'scheduled';
  }

  return 'draft';
}
